import { Box, Container, Stack } from "@mui/material"
import React, { useEffect } from "react"

import Header from "./components/Header"
import { GIT_HASH } from "./env"

export default function App({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    console.log("Git hash", GIT_HASH)
  }, [])

  return (
    <Stack direction="row">
      <Box sx={{ flex: 1 }}>
        {/* <Box
          textAlign="center"
          padding={0.25}
          sx={
            {
              // background: "rgba(var(--mui-palette-background-defaultChannel) / 0.5)",
            }
          }
        >
          <StaggeredList
            gap={2}
            alignItems="center"
            config={SPRING_CONFIGS.quick}
            delay={1_600}
            tertiary
          >
            <Link
              href="mailto:hello@danielconstantin.net"
              variant="caption"
              fontWeight={500}
              fontFamily={MainFont}
              underline="hover"
            >
              Participate in our 🌱 Q1 2026 seed round!
            </Link>
          </StaggeredList>
        </Box> */}
        <Header />
        {/* <HeroSection /> */}
        <Container disableGutters maxWidth="xl" sx={{ paddingTop: 2, paddingX: 3 }}>
          <Stack gap={6} marginTop={4} marginBottom={6} sx={{ minHeight: "100vh" }}>
            {/* <PhotoshootPage /> */}
            {children}
          </Stack>
        </Container>
      </Box>
    </Stack>
  )
}
